import styled from 'styled-components'

export const LinkOnBox = styled.div`
  background-color: #c4c4c4;
  display: inline-flex;
  transform: rotate(90deg);
  margin-right: 10px;
`
